import React from 'react';
import * as Styles from './style';
import { Icon } from 'semantic-ui-react';
import { H5, H6 } from 'components/reusable-css';
import { base64Label } from './util';

const EditLabel = ({ data, handleOpen, setting }) => {
  return (
    <React.Fragment>
      <div className="d-flex align-items-center">
        <Styles.Label setting={setting}>
          {setting ? <H6>{base64Label(data.label)}</H6> : <H5>{base64Label(data.label)}</H5>}
          <Icon name="pencil" onClick={handleOpen} />
        </Styles.Label>
      </div>
    </React.Fragment>
  );
};
export { EditLabel };
